import axios from "axios";

const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const winOrigin = typeof window !== "undefined" ? window.location.origin : "";

// If a frontend was built with a baked-in URL that doesn't match the host the user
// is actually on (e.g. preview URL still embedded in a prod build), fall back to
// the current origin so /api calls are always same-origin and cookies/CORS work.
let resolvedBase = envUrl || winOrigin;
try {
  if (winOrigin && envUrl && new URL(envUrl).host !== new URL(winOrigin).host) {
    resolvedBase = winOrigin;
  }
} catch (_) {
  resolvedBase = envUrl || winOrigin;
}

const BACKEND_URL = resolvedBase;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Bubble up — pages handle their own toasts
    return Promise.reject(err);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
